import { UploadError } from 'store/features/context/types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const DisplayErrors = ({ errors }: { errors: UploadError[] }) => (
    <>
        {errors.map(error => (
            <Box mb='16px' key={error.filename}>
                <Typography paragraph color='#D32F2F' mb={0}>
                    {error.filename}
                </Typography>
                <Typography paragraph mb={0}>
                    {error.error}
                </Typography>
            </Box>
        ))}
    </>
);

export default DisplayErrors;
